import React, { Component, useEffect } from 'react';
import { withSize } from 'react-sizeme';

import { connect } from 'react-redux';
import { withStyles } from "@material-ui/core";
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import Grid from '@mui/material/Grid';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Divider from "@mui/material/Divider";

import ADDIcon from '@mui/icons-material/Add';
import NOFILEIcon from '@mui/icons-material/FindInPageOutlined';

import { STLViewer_MOD } from '../../../../utils';
import STL_Listitem from './STL_Listitem';


//-----------------------------------------------------------------



const useStyles = (theme) => ({

});



//-----------------------------------------------------------------



class STL_Column_ extends Component {

    constructor(props) {
        super(props);

        this.state = {
        };

    }


    render() {

        const { classes } = this.props;

        const { width, height } = this.props.size;

        let STLs = [];
        for (let index = 0; index < this.props.STL_List_Items.length; index++)
            if (this.props.STL_List_Items[index].STLFilePath != "")
                STLs.push({ path: this.props.STL_List_Items[index].STLFilePath, color: this.props.STL_List_Items[index].color });

        //Initializes 3d Object (stlView) as null
        let stlView = null;

        //If STL file is uploaded it's forwarded to STLViewer_MOD to be processed and displayed
        if (STLs.length > 0) {

            stlView = <STLViewer_MOD
                backgroundColor="#fafafa"
                objects={STLs}
            />;

        }

        //If there's no file: Sets bounds to zero and displays NOFILEICON
        else {

            this.props.onSTLBounds([0, 0, 0, 0, 0, 0]);

            stlView = <div
                className={this.props.className}
                style={{
                    width: '100%',
                    height: '100%',
                    overflow: 'hidden',
                }}
            >
                <div style={{
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <NOFILEIcon sx={{ width: '40%', height: '40%', color: '#DCDCDC' }} />
                </div>
            </div>

        }


        return (

            <Grid //Grid for the whole STL Column
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="stretch"
                spacing={1}
                height="50vh"
            >

                <Grid //Grid for 3D render
                    item xs={5}
                    //md={5}
                    sx={{ display: "flex", flexDirection: "column" }}>

                    <Box //Box to display 3D object "stlView"
                        sx={{ flexGrow: 1, m: 1 }}
                        alignItems="center">

                        {stlView}

                    </Box>

                </Grid>

                <Divider orientation="vertical" flexItem sx={{ marginRight: 2, marginLeft: 3 }} />

                <Grid //Grid for STL List including header
                    item xs
                    sx={{ display: "flex", flexDirection: "column" }}>

                    <Box sx={{ flexGrow: 1, m: 2, display: "flex", flexDirection: "column" }}>

                        <Grid //Header for STL list
                            container
                            direction={'row'}
                            alignItems="left"
                            justifyContent="left">

                            <Typography //List header label
                                sx={{ mt: 0, mb: 1 }}
                                variant="h5"
                                component="div">
                                STL-Models
                            </Typography>

                            <Button //Adds new item (Paper) to the STL file list in STL_Listitem.js
                                variant="contained"
                                size="small"
                                startIcon={<ADDIcon />}
                                onClick={() => { this.props.addSTLListItem({ STLFilePath: "", STLFileName: "", material: "" }); }} //Creates empty item/paper to the list
                                sx={{ height: 32, ml: 4 }}
                            >
                                STL-model
                            </Button>

                        </Grid>

                        <Box overflow="auto" sx={{ flexGrow: 1, maxHeight: '39vh', marginTop: 1 }}>
                            {this.props.STL_List_Items.map(function (item, index) { //Displays STL_Listsitem.js
                                return (<STL_Listitem indexItem={index} />)
                            })}
                        </Box>

                    </Box>

                </Grid>

            </Grid>




        );

    }

}



//-----------------------------------------------------------------



const mapStateToProps = (state, props) => {

    return {
        STL_List_Items: state.stlColumn.STL_List_Items,
    };

}

const mapDispatchToProps = (dispatch, props) => {

    return {
        addSTLListItem: (val) => { dispatch({ type: "STL_LIST:ADD_ITEM", value: val }) },
        onSTLBounds: (val) => { dispatch({ type: "STL:BOUNDS", value: val }) }
    };

}


const STL_ColumnMobile = connect(mapStateToProps, mapDispatchToProps)(STL_Column_)
export default withSize({ monitorWidth: true, monitorHeight: true, refreshRate: 25 })(withStyles(useStyles)(STL_ColumnMobile));
